import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChainMaintenanceRoutingModule } from './chain-maintenance-routing.module';
import { ChainMaintenanceComponent } from './chain-maintenance.component';
import { ChainMaintenanceFormComponent } from './chain-maintenance-form/chain-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { ChainMaintenanceFilterComponent } from './chain-maintenance-filter/chain-maintenance-filter.component';
import { ChainTypeDropdownModule } from 'src/app/core/custom-modules/dropdowns/chain-type-dropdown/chain-type-dropdown.module';
import { ChainMaintenanceDetailComponent } from './chain-maintenance-detail/chain-maintenance-detail.component';
import { ChainMaintenanceHandlingFeeModalComponent } from './chain-maintenance-handling-fee-modal/chain-maintenance-handling-fee-modal.component';
import { CompanyDropdownModule } from 'src/app/core/custom-modules/dropdowns/company-dropdown/company-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    ChainMaintenanceRoutingModule,
    ChainTypeDropdownModule,
    CompanyDropdownModule
  ],
  declarations: [ChainMaintenanceComponent, ChainMaintenanceFormComponent, ChainMaintenanceFilterComponent, ChainMaintenanceDetailComponent, ChainMaintenanceHandlingFeeModalComponent],
  entryComponents: [
    ChainMaintenanceFilterComponent,
    ChainMaintenanceHandlingFeeModalComponent
  ]
})
export class ChainMaintenanceModule { }
